import { FC, PropsWithChildren } from 'react';
import { useDevice } from '../../../lib/hooks/device';

const WithDevice: FC<{ tablet?: boolean; mobile?: boolean; desktop?: boolean } & PropsWithChildren> = ({
  children,
  ...props
}) => {
  const device = useDevice();

  if (Object.keys(props).includes(device)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return null;
};

export default WithDevice;
